import { Box, IconButton } from "@mui/material";
import { ArrowDownward, ArrowUpward, UnfoldMore } from "@mui/icons-material";

export type SortableHeaderProps = {
  label: React.ReactNode;
  column: string;
  sortColumn: string;
  sortOrder: string;
  onSort: (column: string) => void;
};

const SortableHeader = ({
  label,
  column,
  sortColumn,
  sortOrder,
  onSort,
}: SortableHeaderProps) => {
  const active = sortColumn === column;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 0.5,
      }}
    >
      <Box component="span" sx={{ flex: 1 }}>
        {label}
      </Box>
      <IconButton
        size="small"
        onClick={() => onSort(column)}
        sx={{ p: 0.25, flexShrink: 0 }}
      >
        {!active ? (
          <UnfoldMore sx={{ fontSize: 18, color: "text.secondary" }} />
        ) : sortOrder === "ASC" ? (
          <ArrowUpward sx={{ fontSize: 16 }} color="primary" />
        ) : (
          <ArrowDownward sx={{ fontSize: 16 }} color="primary" />
        )}
      </IconButton>
    </Box>
  );
};

export default SortableHeader;
